var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-center py-4"},[_c('a',{staticClass:"text-secondary text-decoration-none",attrs:{"href":'https://beian.miit.gov.cn/#/home',"target":"_blank"}},[_vm._v("ICP: "+_vm._s(this.icp))])])
}
var staticRenderFns = []

export { render, staticRenderFns }